import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { LoaderService } from '../shared/services/loader.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import FileSaver from 'file-saver';
import { DATE_CELL } from '../modules/reports/commissions-report/commissions-report.component';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
// const EXCEL_EXTENSION = '.xlsx';

@Injectable({
    providedIn: 'root'
})



export class ExcelService {

    constructor(private loader: LoaderService,) { }

    readSheetOneData(file: File, type: string): Promise<any> {
        if (type !== 'noload') {

            //this.loader.start();
            Swal.fire({
                icon: 'info',
                title: ' Please do not refresh the page or click the <b>Back</b> or <b>Close</b> rather click on <b>Wait</b> button of your browser',
                showConfirmButton: false,
                position: 'center', // Set the position to 'center'
                imageUrl: "../../assets/Home-Connect/loader.gif",
                imageWidth: 400,
                imageHeight: 100,
                imageAlt: "Custom image",
                width: 900
            });
        }
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.onload = (e: any) => {
                const workbook = XLSX.read(e.target.result, { type: 'binary' });
                const sheetName = workbook.SheetNames[0]; // Assuming sheet number 1
                const worksheet = workbook.Sheets[sheetName];
                const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                //this.loader.stop();
                if (type !== 'noload') {
                    Swal.close();
                }
                resolve(data); // Resolve with the data
            };
            fileReader.onerror = (error) => {
                reject(error); // Reject with the error
            };
            fileReader.readAsBinaryString(file);
        });
    }



    public exportAsExcelFileForcomms(json: any[], excelFileName: string, cols: any[]): void {
                console.log("Reduce error start");



        // Detect date column indices from first row
        const dateColIndices: number[] = json.length > 0
            ? json[0].reduce((acc, cell, index) => {
                if (cell?.type === DATE_CELL) acc.push(index);
                return acc;
            }, [])
            : [];

        // Unwrap tagged date objects into actual Date values
        const unwrappedJson: any[][] = json.map(row =>
            row.map(cell =>
                cell?.type === DATE_CELL
                    ? (cell.value ? new Date(cell.value) : '')
                    : cell
            )
        );

        // Prepend header row
        const dataWithHeaders = [cols, ...unwrappedJson];

        // Use aoa_to_sheet instead of json_to_sheet
        const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(dataWithHeaders, { cellDates: true });

        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

        const range = XLSX.utils.decode_range(worksheet['!ref']);

        // Row 0 is header, data starts from row 1
        for (let rowIndex = 1; rowIndex <= range.e.r; rowIndex++) {
            dateColIndices.forEach(colIndex => {
                const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
                const cell = worksheet[cellAddress];
                console.log(`Cell ${cellAddress}:`, cell); // 👈 check what type is coming
                if (cell) {
                    cell.z = 'DD/MM/YYYY'; // force format regardless of type
                }
            });
        }

        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        const todayDate = moment(new Date).format('DD-MM-YYYY');
        // FileSaver.saveAs(data, fileName + '_' + todayDate + EXCEL_EXTENSION);
        FileSaver.saveAs(data, fileName);
    }

     public exportAsExcelFile(json: any[], excelFileName: string, cols: any[]): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let index = range.s.r; index <= range.e.c; ++index) {
      const address = XLSX.utils.encode_col(index) + '1';
      worksheet[address].v = cols[index];
      // worksheet[address].s = {
      //   fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'FFFF00' } },
      //   font: { color: { rgb: 'FF0000' }, bold: true },
      // };
    }

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }


}
